import { createPortal } from "react-dom";
import Toast from "./Toast";
import { useToastContext } from "../App";

const containerStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    zIndex: 12000,
    display: "flex",
    flexDirection: "column",
    gap: "0.75rem",
    padding: "1rem",
    pointerEvents: "none",
};

function ToastContainer() {
    const { toasts, removeToast } = useToastContext();

    if (typeof document === "undefined") {
        return null;
    }

    return createPortal(
        <div style={containerStyle}>
            {toasts.map((toast) => (
                <Toast
                    key={toast.id}
                    id={toast.id}
                    message={toast.message}
                    type={toast.type}
                    duration={toast.duration}
                    onClose={removeToast}
                />
            ))}
        </div>,
        document.body
    );
}

export default ToastContainer;
